export default "__VITE_ASSET__DPL9bQlK__";